// extracted by mini-css-extract-plugin
export var mergingIntoPill = "_jo-1";
export var rowFirst = "_jo-3";
export var rowLast = "_jo-5";
export var rowMiddle = "_jo-4";
export var ticketListScroll = "_jo-2";
export var ticketStack = "_jo-0";